import type { Device } from "../interfaces/EndpointInterfaces";

export type DevicePlatform = "mac" | "linux" | "windows" | "other";

export function getDevicePlatform(device: Pick<Device, "os" | "OperatingSystem">): DevicePlatform {
  const operatingSystems = [device.os, device.OperatingSystem];

  for (const value of operatingSystems) {
    const os = value?.trim().toLowerCase() || "";

    if (/\b(?:windows|win32|win64|winnt)\b/.test(os)) return "windows";
    if (/\b(?:mac(?:os|intosh)?|mac\s+os|os\s*x|darwin)\b/.test(os)) return "mac";
    if (/\b(?:linux|almalinux|ubuntu|debian|centos|rhel|red\s+hat|rocky|fedora|(?:open)?suse|sles|amazon\s+linux|amzn|alpine|arch|manjaro|mint|oracle\s+linux|kali|gentoo|nixos|raspbian|raspberry\s+pi\s+os|pop!_os)\b/.test(os)) return "linux";
  }

  return "other";
}

export function groupDevicesByPlatform(devices: Device[]): Record<DevicePlatform, Device[]> {
  const groups: Record<DevicePlatform, Device[]> = {
    mac: [],
    linux: [],
    windows: [],
    other: [],
  };

  for (const device of devices) {
    groups[getDevicePlatform(device)].push(device);
  }

  return groups;
}
